import React, { useEffect } from 'react'
import qs from 'qs'

import { IConnect } from './types'
import CreateCompanyPage from './create-company-page'

import { SubscriptionPlanEnum } from '@vacationtracker/shared/types/company'

// Preload signup assets for better UX
const COMMON_ASSETS = [
  '/signup/gdpr-icon.png',
  '/signup/soc2-icon.png',
  '/signup/testimonial-avatar.png',
]

const preloadImages = (assets: string[]) => {
  assets.forEach(src => {
    const img = new Image()
    img.src = src
  })
}

const Connect = ({ location }: IConnect): React.ReactElement => {

  const queryParams = qs.parse(location.search, { ignoreQueryPrefix: true })

  // Preload common images on mount
  useEffect(() => {
    preloadImages(COMMON_ASSETS)
  }, [])

  // Preload flow-specific images once flow is determined
  useEffect(() => {
    if (queryParams?.subscriptionPlan) {
      const preselectedPlan = queryParams.subscriptionPlan === 'Free' ? SubscriptionPlanEnum.freemium : queryParams.subscriptionPlan as SubscriptionPlanEnum | null
      if (
        preselectedPlan
        && [SubscriptionPlanEnum.freemium, SubscriptionPlanEnum.core, SubscriptionPlanEnum.complete].includes(preselectedPlan)
      ) {
        localStorage.setItem('vtSubscriptionPlan', preselectedPlan)
      }
    }
  },[queryParams?.subscriptionPlan])

  return <CreateCompanyPage location={location}></CreateCompanyPage>
}

export default Connect